import React, { useState, useEffect } from "react";

const DailyReport = ({ date }) => {
  const [dailyData, setDailyData] = useState([]);
  const [filteredData, setFilteredData] = useState([]); // State for filtered data
  const [selectedDate, setSelectedDate] = useState(date); // Selected date state
  const [searchTerm, setSearchTerm] = useState(""); // State for search term
  const [modalLocation, setModalLocation] = useState(null);

  useEffect(() => {
    fetchDailyData(selectedDate);
  }, [selectedDate]);

  useEffect(() => {
    // Apply search filter
    if (searchTerm.trim() === "") {
      setFilteredData(dailyData);
    } else {
      const lowerCaseSearchTerm = searchTerm.toLowerCase();
      const filtered = dailyData.filter((employee) =>
        Object.values(employee)
          .join(" ")
          .toLowerCase()
          .includes(lowerCaseSearchTerm)
      );
      setFilteredData(filtered);
    }
  }, [searchTerm, dailyData]);

  const fetchDailyData = async (date) => {
    const queryParam = selectedDate ? "?startDate=" +selectedDate : "";
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/attendance/role-based/time-sheets${queryParam}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      const data = await response.json();
      setDailyData(data);
      setFilteredData(data); // Initialize filtered data with fetched data
    } catch (error) {
      console.error("Error fetching daily attendance data:", error);
      setDailyData([]);
      setFilteredData([]);
    }
  };

  const getLast30Days = () => {
    const dates = [];
    const today = new Date();
    for (let i = 0; i < 30; i++) {
      const date = new Date();
      date.setDate(today.getDate() - i);
      dates.push(formatDate(date));
    }
    return dates;
  };

  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${year}-${month}-${day}`; // YYYY-MM-DD format
  };

  const handleDateChange = (event) => {
    setSelectedDate(event.target.value); // Update the selected date
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value); // Update the search term
  };

  const showMapModal = (lat, long) => {
    setModalLocation({ lat, long });
  };

  const closeModal = () => {
    setModalLocation(null);
  };

  return (
    <div className="card shadow">
      <div className="card-header bg-primary text-white d-flex align-items-center justify-content-between">
        <h5>Daily Attendance Report</h5>
        <div className="d-flex align-items-center">
          {/* Search Input */}
          <input
            type="text"
            className="form-control me-3"
            style={{ maxWidth: "200px" }}
            placeholder="Search..."
            value={searchTerm}
            onChange={handleSearchChange}
          />
          {/* Date Picker */}
          <select
            className="form-select"
            value={selectedDate}
            onChange={handleDateChange}
          >
            {getLast30Days().map((date, index) => (
              <option key={index} value={date}>
                {date}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div className="card-body">
        {filteredData.length > 0 ? (
          <div className="table-responsive">
            <table className="table table-bordered table-hover">
              <thead className="table-dark">
                <tr>
                  <th>Employee</th>
                  <th>Login Time</th>
                  <th>Logout Time</th>
                  <th>Login Location</th>
                  <th>Logout Location</th>
                  <th>Task</th>
                </tr>
              </thead>
              <tbody>
                {filteredData.map((employee, idx) => {
                  return (
                    <tr key={idx}>
                      <td>{employee.employeeName}</td>
                      <td>{employee.loginTime || "Not Available"}</td>
                      <td>{employee.logoutTime || "Not Available"}</td>
                      <td>
                        {employee.loginLocation ? (
                          <span
                            className="text-primary cursor-pointer"
                            onClick={() => {
                              const [lat, long] =
                                employee.loginLocation
                                  .replace("Lat: ", "")
                                  .replace("Long: ", "")
                                  .split(", ");
                              showMapModal(lat, long);
                            }}
                          >
                            View Map
                          </span>
                        ) : (
                          "Not Available"
                        )}
                      </td>
                      <td>
                        {employee.logoutLocation ? (
                          <span
                            className="text-primary cursor-pointer"
                            onClick={() => {
                              const [lat, long] =
                                employee.logoutLocation
                                  .replace("Lat: ", "")
                                  .replace("Long: ", "")
                                  .split(", ");
                              showMapModal(lat, long);
                            }}
                          >
                            View Map
                          </span>
                        ) : (
                          "Not Available"
                        )}
                      </td>
                      <td>{employee.taskDiscription || "No Task Provided"}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        ) : (
          <p>No data available for this date.</p>
        )}
      </div>

      {/* Modal */}
      {modalLocation && (
        <div className="modal fade show d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Location Map</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={closeModal}
                ></button>
              </div>
              <div className="modal-body">
                <iframe
                  width="100%"
                  height="400"
                  src={`https://www.google.com/maps?q=${modalLocation.lat},${modalLocation.long}&z=15&output=embed`}
                  frameBorder="0"
                  allowFullScreen
                  title="Google Map"
                ></iframe>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={closeModal}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DailyReport;
